import { push } from 'react-router-redux';
import actions from '../actions';
import { put, call, takeEvery, select } from 'redux-saga/effects'
import * as enterpriseApis from '../apis/enterpriseApis';

function* getEnterprises(action) {
    const state = yield select();
    const token = state.userAccount.token;
    try {
        let enterprises = yield call(enterpriseApis.getEnterprisesApi, token);
        yield put({type: actions.GET_ENTERPRISES_SUCCESS, enterprises});
    } catch(err) {
        console.log("Failed to get enterprises ", err);
        yield put({type: actions.GET_ENTERPRISES_FAILED, errorMessage: err});
    }
}

const expertsSagas = [
    takeEvery(actions.GET_ENTERPRISES_REQUEST, getEnterprises)
]
export default expertsSagas;


// WEBPACK FOOTER //
// ./src/sagas/enterpriseSagas.js